import { ProjectElementNode } from '@deltek/specification-client/core/Models/productListingDetail'
import { OMElementLibraryElementType } from '@deltek/specification-client/core/Models/projectElement'
import ConfirmationDialog from 'components/ConfirmationDialog/ConfirmationDialog'
import { ExecutionResult } from 'graphql'
import React from 'react'
import ImportDuplicateVersionDialogActions from './ImportDuplicateVersionDialogActions'
import ImportDuplicateVersionDialogContent from './ImportDuplicateVersionDialogContent'

export interface ImportDuplicateVersionProps {
    showDuplicateImportDialoge: boolean
    setShowDuplicateImportDialouge: (show: boolean) => void
    startImport: (isImportOverwrite: boolean) => void
    familyVersionsToImport: ProjectElementNode[]
    setFamilyVersionsToImport: (familyVersions: ProjectElementNode[]) => void
    duplicateOfficeMasterImportFamilies: ProjectElementNode[]
    showGlobalSnackbar: (options?: any) => Promise<ExecutionResult<any>>
}

const ImportDuplicateVersionDialog: React.FC<ImportDuplicateVersionProps> = ({
    showDuplicateImportDialoge,
    setShowDuplicateImportDialouge,
    familyVersionsToImport,
    setFamilyVersionsToImport,
    startImport,
    duplicateOfficeMasterImportFamilies,
    showGlobalSnackbar,
}) => {
    const handleOverwrite = React.useCallback(() => {
        // Check if all families have a version selected... We can't overwrite if there's no version selected to overwrite
        const familyBuckets = duplicateOfficeMasterImportFamilies.filter(
            (family) =>
                family.elementType ===
                OMElementLibraryElementType.PRODUCTFAMILYBUCKET
        )
        const allFamilyHasVersionSelected = familyBuckets.every(
            (familyBucket) =>
                familyVersionsToImport.some(
                    (familyVersion) =>
                        familyVersion.parentNodeId === familyBucket.id
                )
        )

        if (allFamilyHasVersionSelected) {
            startImport(true)
        } else {
            showGlobalSnackbar({
                variables: {
                    message:
                        'Please select the family versions you would like to overwrite before proceeding.',
                    variant: 'warning',
                    id: 'ProjectImportPage_ImportOverwriteMissingSelection',
                },
            })
        }
    }, [duplicateOfficeMasterImportFamilies, familyVersionsToImport])

    const handleCreateNewVersion = React.useCallback(() => {
        startImport(false)
    }, [familyVersionsToImport])

    return (
        <ConfirmationDialog
            dialogHeading="A Duplicate Family Exists"
            openDialog={showDuplicateImportDialoge}
            handleDialogClose={() => setShowDuplicateImportDialouge(false)}
            removeHeaderBorder
            size="large"
            contentNode={
                <ImportDuplicateVersionDialogContent
                    setFamilyVersionsToImport={setFamilyVersionsToImport}
                    duplicateOfficeMasterImportFamilies={
                        duplicateOfficeMasterImportFamilies
                    }
                />
            }
            cancelText="Cancel"
            customDialogActions={
                <ImportDuplicateVersionDialogActions
                    onCreateNewVersion={handleCreateNewVersion}
                    onOverrideVersion={handleOverwrite}
                />
            }
            confirmMessage=""
        />
    )
}

export default ImportDuplicateVersionDialog
